<template>
  <div>
    <BaseHeaderBar :showCustomerService="false" :showBackButton="true" title="" />
    <div class="login">
      <div class="title">
        {{ title }}
      </div>

      <form class="login-content" @submit.prevent="onSubmit">
        <div class="input-block">
          <input v-model.trim="phone" type="tel" autofocus placeholder="Masukkan nomor handphone dengan awalan 08"
            maxlength="13" />
        </div>
        <div v-if="showPasswordInput" class="input-block">
          <input v-model.trim="password" maxlength="8" type="tel" class="password" :placeholder="tipText" />
        </div>
        <div class="input-block verify-code-block">
          <input v-model.trim="verifyCode" type="tel" maxlength="4"
            placeholder="Masukkan 4 digit angka kode verifikasi" />
          <div class="verify-code-btn" v-if="isGetCode" @click="getVerifyCode">
            Dapatkan kode verifikasi
          </div>
          <div class="verify-code-btn count-down" v-else>{{ countDown }}s</div>
        </div>
        <button type="submit" :class="['confirm-btn', showPasswordInput ? 'near' : 'far']">
          {{ buttonText }}
        </button>
      </form>

      <van-dialog v-model="showCodeChannelDialog" :showConfirmButton="false" :close-on-click-overlay="!isSendingCode"
        class="code-channel-dialog">
        <div class="code-channel-box">
          <i class="channel-close-btn" role="button" tabindex="0" aria-label="Tutup" @click="closeCodeChannelDialog"
            @keyup.enter="closeCodeChannelDialog"></i>
          <div :class="['channel-badge', codeChannel]">{{ isWaCodeChannel ? 'WA' : 'SMS' }}</div>
          <h3 class="channel-title">{{ channelText.title }}</h3>
          <p class="channel-desc">{{ channelText.description }}</p>
          <div v-if="isWaCodeChannel" class="channel-tips">
            <p v-for="(tip, index) in channelText.tips" :key="index">{{ tip }}</p>
          </div>
          <div class="channel-actions">
            <button type="button" class="channel-switch-btn" :disabled="isSendingCode" @click="switchCodeChannel">
              {{ switchCodeChannelText }}
            </button>
            <button type="button" class="channel-send-btn" :disabled="isSendingCode" @click="sendVerifyCode">
              Kirim
            </button>
          </div>
        </div>
      </van-dialog>

      <van-dialog v-model="visible" :showConfirmButton="false" close-on-click-overlay class="verify-img-dialog">
        <h3 class="verify-title">Diperlukan verifikasi</h3>
        <div class="verify-body">
          <div class="verify-img">
            <img class="verifyImg" ref="verifyImg" @click="refreshVerifyCode" />
            <div class="refresh">
              <span @click="refreshVerifyCode">Klik gambar untuk refresh</span>
              <img src="@/assets/img/refresh-icon.png" alt="" />
            </div>
          </div>
          <div class="verify-input-box">
            <input v-model="imgVerifyCode" placeholder="Silakan masukkan kode verifikasi grafis" type="tel"
              maxlength="4" />
            <p class="error-info">{{ errorInfo }}</p>
          </div>
          <div class="handleBtn">
            <button type="button" class="verify-cancel-btn" @click="onCloseDialog()">
              Batal
            </button>
            <button type="button" class="verify-confirm-btn" @click="onVerify">
              Yakin
            </button>
          </div>
        </div>
      </van-dialog>
      <van-dialog v-model="showContactMsg" :showConfirmButton="false">
        <div class="showContactMsg">
          <h3>Tips Penting</h3>
          <p>Harap aktifkan izin buku alamat sesuai persyaratan berikut untuk terus menggunakannya:</p>
          <p>Harap aktifkan izin "Akses Penuh" untuk (nama aplikasi) di "Pengaturan" - "Privasi" - "Kontak" di iPhone
            Anda.</p>
        </div>
      </van-dialog>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Toast, Dialog, Icon } from 'vant'
import request from '@/utils/request'
import { validatePhoneNumber, validatePassword, validateVerifyCode } from '@/utils/validator'
import dialogVisible from '@/mixins/dialogVisible'
import { baseURL } from '@/config'
import { getContactsFromStorage } from '@/utils/submitContacts'
Vue.use(Icon)

Vue.use(Toast)
const maxTime = 150
let timer
const clearTimer = () => {
  timer && clearTimeout(timer) && (timer = null)
}
const titleMap = {
  forgetPassword: 'Lupa Password',
  messageLogin: 'Login dengan SMS',
  register: 'Daftar'
}
const buttonText = {
  forgetPassword: 'Yakin',
  messageLogin: 'Login',
  register: 'Daftar'
}
const apiMap = {
  forgetPassword: 'usdrerForgetPassword',
  messageLogin: 'usdrerLogin',
  register: 'usdrerRegistration'
}

const messageTypeMap = {
  forgetPassword: 3,
  messageLogin: 2,
  register: 1
}

const codeTypeSms = 1
const codeTypeWhatsapp = 2
const codeChannelSms = 'sms'
const codeChannelWhatsapp = 'whatsapp'
const whatsappSentStorageKey = 'clh5WhatsappCodeSentMap'
const channelTextMap = {
  whatsapp: {
    title: 'Dapatkan kode verifikasi WhatsApp',
    description: 'Kode verifikasi telah dikirim ke WhatsApp Anda, harap periksa pesan WhatsApp Anda. Jika belum menerima, mohon perhatikan!',
    tips: [
      'Ponsel harus terpasang aplikasi WhatsApp',
      'WhatsApp harus dalam keadaan aktif / terbuka agar dapat menerima kode verifikasi',
      'Nomor ponsel yang didaftarkan harus memiliki akun WhatsApp'
    ]
  },
  sms: {
    title: 'Dapatkan kode verifikasi SMS',
    description: 'Kode verifikasi telah dikirim ke ponsel Anda, harap periksa SMS. Jika belum menerima, silakan cek folder spam / sampah SMS',
    tips: []
  }
}

export default {
  name: 'LoginForm',
  props: {
    type: {
      type: String,
      required: true
    }
  },
  mixins: [dialogVisible],
  data () {
    return {
      phone: '',
      password: '',
      verifyCode: '',
      imgVerifyCode: '',
      isGetCode: true,
      countDown: maxTime,
      verifyImg: '',
      verifyImgCodes: [
        {
          value: ''
        },
        {
          value: ''
        },
        {
          value: ''
        },
        {
          value: ''
        }
      ],
      errorInfo: '',
      showContactMsg: false,
      showCodeChannelDialog: false,
      codeChannel: codeChannelSms,
      codeType: codeTypeSms,
      isSendingCode: false
    }
  },
  components: {
    [Dialog.Component.name]: Dialog.Component
  },
  computed: {
    title () {
      return titleMap[this.type]
    },
    buttonText () {
      return buttonText[this.type]
    },
    showPasswordInput () {
      return this.type === 'forgetPassword' || this.type === 'register'
    },
    tipText () {
      if (this.type === 'register') {
        return 'Atur 8 digit password'
      } else {
        return 'Masukkan 8 digit angka password'
      }
    },
    isWaCodeChannel () {
      return this.codeChannel === codeChannelWhatsapp
    },
    channelText () {
      return channelTextMap[this.codeChannel]
    },
    switchCodeChannelText () {
      return this.isWaCodeChannel ? 'SMS' : 'WhatsApp'
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.$nextTick(() => {
          this.getImgVerifyCode()
          this.$refs.input0[0].focus()
        })
      }
    }
  },
  created () {
    if (this.type === 'register') {
      const contant = getContactsFromStorage()
      if (contant.length === 0) {
        this.showContactMsg = true
      }
    }
  },
  methods: {
    validatePhoneNumber () {
      if (!this.phone) {
        Toast('Masukkan nomor handphone dengan awalan 08')
        return false
      }
      if (!validatePhoneNumber(this.phone)) {
        Toast('Nomor handphone salah')
        return false
      }
      return true
    },
    validate () {
      if (!this.validatePhoneNumber()) return false
      if (this.showPasswordInput) {
        if (!this.password) {
          Toast(this.tipText)
          return false
        }
        if (!validatePassword(this.password)) {
          Toast('Password salah')
          return false
        }
      }
      if (!this.verifyCode) {
        Toast('Masukkan 4 digit angka kode verifikasi')
        return false
      }
      if (!validateVerifyCode(this.verifyCode)) {
        Toast('Kode verifikasi salah')
        return false
      }
      return true
    },
    startCountDown () {
      if (this.countDown <= 0) {
        this.reset()
      } else {
        timer = setTimeout(() => {
          this.countDown--
          this.startCountDown()
        }, 1000)
      }
    },
    getVerifyCode () {
      if (!this.validatePhoneNumber()) return
      if (!validatePassword(this.password) && this.type !== 'messageLogin') {
        Toast('Masukkan 8 digit angka password')
        return false
      }
      this.codeChannel = this.hasSentWhatsappToday() ? codeChannelSms : codeChannelWhatsapp
      this.showCodeChannelDialog = true
    },
    getTodayKey () {
      const now = new Date()
      const month = `${now.getMonth() + 1}`.padStart(2, '0')
      const date = `${now.getDate()}`.padStart(2, '0')
      return `${now.getFullYear()}-${month}-${date}`
    },
    getWhatsappSentMap () {
      try {
        return JSON.parse(localStorage.getItem(whatsappSentStorageKey)) || {}
      } catch (err) {
        return {}
      }
    },
    hasSentWhatsappToday () {
      const sentMap = this.getWhatsappSentMap()
      return sentMap[this.phone] === this.getTodayKey()
    },
    markWhatsappSentToday (phone = this.phone) {
      try {
        const sentMap = this.getWhatsappSentMap()
        sentMap[phone] = this.getTodayKey()
        localStorage.setItem(whatsappSentStorageKey, JSON.stringify(sentMap))
      } catch (err) {
        return false
      }
      return true
    },
    switchCodeChannel () {
      if (this.isSendingCode) return
      this.codeChannel = this.isWaCodeChannel ? codeChannelSms : codeChannelWhatsapp
    },
    closeCodeChannelDialog () {
      if (this.isSendingCode) return
      this.showCodeChannelDialog = false
    },
    getSendCodeApi (codeType) {
      return codeType === codeTypeWhatsapp ? 'sendWaSms' : 'usdrersendMessages'
    },
    sendVerifyCode () {
      if (!this.validatePhoneNumber()) return
      if (this.isSendingCode) return
      const codeType = this.isWaCodeChannel ? codeTypeWhatsapp : codeTypeSms
      const codeChannel = this.codeChannel
      const phone = this.phone
      const postData = {
        usdrerPhone: phone,
        tydrpe: messageTypeMap[this.type],
        smdrsType: 1
      }
      this.imgVerifyCode && (postData.imdrgCode = this.imgVerifyCode)
      this.isSendingCode = true
      request.post(this.getSendCodeApi(codeType), postData)
        .then(() => {
          this.codeType = codeType
          if (codeType === codeTypeWhatsapp) {
            this.markWhatsappSentToday(phone)
          }
          Toast(channelTextMap[codeChannel].description)
          this.showCodeChannelDialog = false
          this.countDown = maxTime
          this.isGetCode = false
          this.startCountDown()
        })
        .catch(err => {
          this.showCodeChannelDialog = false
          if (err.code === 504) {
            this.visible = true
          }
          this.reset()
        })
        .finally(() => {
          this.isSendingCode = false
        })
    },
    getImgVerifyCode () {
      this.$refs.verifyImg.src = `${baseURL}usdrergetGraphic?usdrerPhone=${this.phone}&t=${+Date.now()}`
    },
    reset () {
      clearTimer()
      this.isGetCode = true
      this.countDown = maxTime
    },
    onSubmit () {
      if (!this.validate()) return
      if (this.flag) return
      this.flag = true
      const postData = {
        usdrerPhone: this.phone,
        smdrs_Verificationcode: this.verifyCode,
        smdrsType: 1,
        codeType: this.codeType
      }
      if (this.type === 'forgetPassword') {
        postData.usdrerPassword = this.password
      } else if (this.type === 'messageLogin') {
        postData.lodrginType = 2
      } else if (this.type === 'register') {
        const ixabisoelinye = sessionStorage.getItem('ixabisoelinye')
        if (ixabisoelinye) {
          postData.ixabisoelinye = ixabisoelinye
        }
        postData.usdrerPassword = this.password
        postData.prdromotionChannel = 'AppStore'
        postData.apitype = sessionStorage.getItem('apitype')
      }
      request.post(apiMap[this.type], postData)
        .then(res => {
          if (this.type === 'forgetPassword') {
            const { query } = this.$route
            this.$router.push({
              path: '/login',
              query
            })
          } else if (this.type === 'register' || this.type === 'messageLogin') {
            this.$store.commit('recordInfo', {
              type: 'userInfo',
              value: res
            })
            if (this.type === 'register') {
              this.addressBook()
            }
            localStorage.setItem('userInfo', JSON.stringify(res))
            this.$router.push('/home1')
          }
        })
        .finally(() => {
          this.flag = false
        })
    },
    onVerify () {
      const postData = {
        usdrerPhone: this.phone,
        grdraphicCode: this.imgVerifyCode
      }
      request.post('usdrercheckGraphic', postData)
        .then(res => {
          Toast('Verifikasi Berhasil')
          this.errorInfo = ''
          this.visible = false
          this.sendVerifyCode()
        }).catch(() => {
          this.getImgVerifyCode()
          this.errorInfo = 'Kode verifikasi grafis salah'
        })
    },
    refreshVerifyCode () {
      this.getImgVerifyCode()
    },
    onInput (index) {
      if (this.verifyImgCodes[index].value && index < 3) {
        console.log('onInput', index)
        this.$refs[`input${index + 1}`][0].focus()
      }
    },
    onDelete (index) {
      if (index > 0) {
        this.$refs[`input${index - 1}`][0].focus()
        console.log('onDelete', index)
      }
    }
  },
  deactivated () {
    this.reset()
  }
}
</script>

<style scoped lang="less">
.login {
  padding: 0 37px;

  .title {
    font-weight: bold;
    font-size: 60px;
    color: #000000;
    margin-top: 200px;
    margin-bottom: 100px;
    text-align: center;
  }
}

.input-block {
  display: flex;
  align-items: center;
  height: 94px;
  background: #ffffff;
  box-shadow: 2px 8px 0px 0px #000000;
  border-radius: 47px;
  border: 2px solid #000000;

  &:nth-child(n + 2) {
    margin-top: 50px;
  }

  input {
    display: block;
    width: 100%;
    height: 88px;
    line-height: 88px;
    padding-left: 20px;
    border: none;
    border-radius: 10px;
    box-sizing: border-box;
    font-size: 32px;
    color: #000;
    background: none;

    &::placeholder {
      color: #000;
      font-size: 24px;
    }

    &:-webkit-autofill {
      transition: background-color 5000s ease-in-out 0s;
    }
  }
}

.password {
  -webkit-text-security: disc;
}

.verify-code-block {
  position: relative;
  display: flex;

  input {
    flex: 1;
    border-radius: 10px 0 0 10px;
  }
}

.verify-code-btn {
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
  width: 217px;
  height: 94%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 24px;
  color: #ffd050;
}

.count-down {
  padding-top: 0;
  line-height: 88px;
  text-align: center;
  font-size: 34px;
}

.confirm-btn {
  .submit-btn;
  width: 100%;
  margin-top: 170px;
}

.code-channel-dialog {
  width: 632px;
  border-radius: 34px;
  overflow: visible;
  background: transparent;
}

.code-channel-box {
  position: relative;
  padding: 44px 38px 36px;
  border: 6px solid #000;
  border-radius: 34px;
  box-sizing: border-box;
  text-align: left;
  background-color: #ffd050;
  box-shadow: 14px 14px 0 #000;
}

.channel-close-btn {
  position: absolute;
  top: 24px;
  right: 24px;
  width: 36px;
  height: 36px;
  cursor: pointer;
  border-radius: 50%;
  background-color: #000;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 17px;
    left: 4px;
    width: 28px;
    height: 2px;
    border-radius: 2px;
    background-color: #ffd050;
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }
}

.channel-badge {
  display: inline-block;
  width: 132px;
  height: 64px;
  line-height: 64px;
  border: 4px solid #000;
  border-radius: 0;
  margin-bottom: 24px;
  font-size: 32px;
  font-weight: 600;
  color: #ffd050;
  text-align: center;
  background-color: #000;

  &.whatsapp {
    color: #fff;
    background-color: #128c7e;
  }
}

.channel-title {
  line-height: 42px;
  font-size: 30px;
  font-weight: 600;
  color: #1c2f51;
}

.channel-desc {
  line-height: 36px;
  margin-top: 22px;
  font-size: 24px;
  color: #1b1b1b;
}

.channel-tips {
  margin-top: 24px;
  padding: 22px 24px;
  border: 4px solid #000;
  border-radius: 0;
  background-color: #fff;
  text-align: left;

  p {
    position: relative;
    line-height: 32px;
    padding-left: 22px;
    font-size: 22px;
    color: #1b1b1b;

    &::before {
      content: '';
      position: absolute;
      top: 13px;
      left: 0;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: #000;
    }

    &:nth-child(n + 2) {
      margin-top: 12px;
    }
  }
}

.channel-actions {
  display: flex;
  margin-top: 34px;
  padding-top: 4px;
}

.channel-switch-btn,
.channel-send-btn {
  flex: 1;
  height: 80px;
  line-height: 80px;
  border: 4px solid #000;
  border-radius: 0;
  font-size: 28px;
  font-weight: 600;
}

.channel-switch-btn {
  color: #000;
  background-color: #fff;
}

.channel-send-btn {
  margin-left: 18px;
  color: #fff;
  background-color: #000;
}

.channel-switch-btn:disabled,
.channel-send-btn:disabled {
  opacity: 0.6;
}

.verify-title {
  line-height: 110px;
  font-size: 38px;
  font-weight: bold;
  color: #000;
  text-align: center;
}

.verify-img {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 30px;

  .verifyImg {
    width: 295px;
    height: 92px;
    border-radius: 92px;
    margin-bottom: 10px;
    background: #fff;
  }

  .refresh {
    display: flex;
    align-items: center;
    margin-top: 15px;

    span {
      color: #000;
      font-size: 24px;
      font-weight: 500;
    }

    img {
      width: 20px;
      height: 25px;
      margin-left: 10px;
    }
  }
}

.refresh-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 78px;
  height: 100%;
  background-color: @theme-color;
  border-radius: 0px 8px 8px 0px;
  cursor: pointer;

  img {
    width: 40px;
    height: 40px;
  }
}

.verify-input-box {
  display: flex;
  justify-content: space-between;
  margin: 0 50px;
  margin-top: 24px;

  div {
    flex: 1;

    &:nth-child(n + 2) {
      margin-left: 64px;
    }
  }

  input {
    width: 100%;
    height: 94px;
    line-height: 94px;
    padding: 0;
    padding-left: 20px;
    border: none;
    border-radius: 8px;
    box-sizing: border-box;
    font-size: 30px;
    color: #000;
    background: #dfcbbe;
  }

  input::placeholder {
    font-weight: 500;
    font-size: 26px;
    color: #000;
    opacity: 0.8;
  }

  .error-info {
    font-size: 24px;
    color: #fff;
    position: absolute;
    right: 80px;
    line-height: 88px;
  }
}

.handleBtn {
  display: flex;
  padding: 0 30px;
  gap: 20px;
  margin-top: 52px;
  margin-bottom: 84px;

  .verify-cancel-btn {
    .cancel-btn;
  }

  .verify-confirm-btn {
    .submit-btn;
  }
}

.showContactMsg {
  text-align: center;
  padding: 15px 10px;

  h3 {
    margin-bottom: 10px;
    margin-top: 25px;
  }

  p {
    line-height: 40px;
    padding: 10px
  }
}
</style>
